import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useModal } from '@/providers/modal';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { useGetDeleteUserStatus } from '@/query/queries/user/useGetDeleteUserStatus';
import { AccountDeleteActionModal } from '../../modals/AccountDeleteActionModal';
import { AccountDeleteConfirmModal } from '../../modals/AccountDeleteConfirmModal';

export const AccountDelete = () => {
  const { openModal } = useModal();
  const { t } = useTranslation('profile');
  const { data } = useGetDeleteUserStatus();

  const onDeleteProfile = useCallback(async () => {
    data?.can_delete
      ? openModal(MODAL_IDS.account_delete_confirm_modal)
      : openModal(MODAL_IDS.account_delete_action_modal);
  }, [data?.can_delete]);

  if (!data) return null;

  return (
    <>
      <button
        type="button"
        onClick={onDeleteProfile}
        className="profile_page__btn_delete"
      >
        {t('delete_my_account')}
      </button>
      <AccountDeleteActionModal />
      <AccountDeleteConfirmModal />
    </>
  );
};
